import { AssociatedDataType } from "./common";

/**
 * 原稿本文取得の判別結果。
 * "PRESENT" | "MISSING_S3" | "CORRUPT_ZIP" はサーバー側 ManuscriptContentStatus と対応する。
 * "FETCH_ERROR" はサーバーから明確な判別結果を得られなかった場合（GraphQL呼び出し自体の失敗、
 * リトライ後も失敗）のクライアント側フォールバック用ステータスで、サーバーが返すことはない。
 */
export type ManuscriptContentStatus = "PRESENT" | "MISSING_S3" | "CORRUPT_ZIP" | "FETCH_ERROR";

export interface Manuscript {
  key?: string;
  content?: string;
  title?: string;
  novelId?: string;
  associatedData?: ManuscriptAssociatedDataType;
  manuscriptFolderId?: string;
  lastModified?: string;
  versions?: Version[];
  /**
   * 本文取得済みか。`content` の初期値（空文字）と「本文が空の原稿」を区別するために使う。
   * 未取得時は undefined。
   */
  contentLoaded?: boolean;
  /** 本文取得の判別結果。取得完了後にのみ設定される（判別のみに使用し、UI表示では区別しない） */
  contentStatus?: ManuscriptContentStatus;
}

export interface ManuscriptFolderList {
  novelId: string;
  items: ManuscriptFolder[];
}

export interface ManuscriptFolder {
  manuscriptFolderId: string;
  name: string;
  manuscriptKeys: string[];
}

export type ManuscriptAssociatedDataType = AssociatedDataType & {
  nolaNovel: {};
};

export interface MoveManuscript {
  novelId: string;
  key: string;
  direction: string;
}

export interface ShowFlags {
  isShowPlots: boolean;
  isShowCharacters: boolean;
  isShowWorldViews: boolean;
  isShowMemo: boolean;
}

export interface SearchTextIndex {
  from: number;
  to: number;
}

export interface Version {
  isLatest: boolean;
  versionId: string;
  lastModified: string;
}

export interface CreateManuscriptFolder {
  novelId: string;
  name: string;
}

export interface UpdateManuscriptFolder {
  novelId: string;
  manuscriptFolders: ManuscriptFolder[];
}

export const Theme = {
  /** ノーマル */
  default: "default",
  /** ダークモード */
  dark: "dark",
  /** セピアモード */
  sepia: "sepia",
  /** 黒板モード */
  blackboard: "blackboard",
  /** 太字モード */
  bold: "bold",
} as const;
// eslint-disable-next-line no-redeclare
export type Theme = typeof Theme[keyof typeof Theme];

export const CountType = {
  /** 全文字数 */
  onlyCharacter: "onlyCharacter",
  /** 空白を含む全文字数 */
  addBlank: "addBlank",
  /** 改行を含む全文字数 */
  addNewLine: "addNewLine",
  /** 空白/改行を含む全文字数 */
  all: "all",
} as const;
// eslint-disable-next-line no-redeclare
export type CountType = typeof CountType[keyof typeof CountType];
